import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { IUser } from 'ng-client-auth'
import { ODataService } from 'common-services'

@Injectable()
export class UserODataService extends ODataService<IUser> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'Users'
  }
}
